import { RSAA } from 'redux-api-middleware';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';

export const REQUEST_GET_RATING = 'REQUEST_GET_RATING';
export const REQUEST_RESET_STARS = 'REQUEST_RESET_STARS';

const host = process.env.BACKEND_URL;

// Init state
const initialState = {
  firstItems: {}, // тут храним первый рейтинг группы,учителя ( и весь рейтинг по школе если есть (причем в type = school, scope = all тоже здесь так как это всегда одна колонка со списком т к школа одна))
  allGroups: {}, // тут храним все списки груп если зафетчили по открытию чтобы можно было листать
  allTeachers: {}, // тут храним все списки учителей с рейтингами их всех учеников если их школа зафетчила по открытию кнопки чтобы можно было листать (то есть это для юзера школа чтобы он мог смотреть все рейтинги своих учителей закрепленных)
  ratingType: 'teacher', // это на каком табе мы находимcя
  opened: null,
  saveResponse: null,
  loading: false,
  error: null,
};

const starRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      if (action.meta?.request === REQUEST_GET_RATING) {
        return {
          ...state,
          loading: true,
          error: null,
        };
      }
      return state;

    case SUCCESS:
      if (action.meta?.request === REQUEST_GET_RATING) {
        const { scope, ratingType } = action.meta;
        const { payload } = action;
        if (scope === 'first') {
          return {
            ...state,
            loading: false,
            firstItems: payload,
            ratingType,
            error: null,
          };
        }
        if (scope === 'all') {
          if (ratingType === 'groups') {
            return {
              ...state,
              loading: false,
              allGroups: payload.groupRatings || [],
              ratingType,
              error: null,
            };
          }

          if (ratingType === 'teacher') {
            return {
              ...state,
              loading: false,
              allTeachers: payload.teacherRating || [],
              ratingType,
              error: null,
            };
          }

          if (ratingType === 'school') {
            return {
              ...state,
              loading: false,
              firstItems: payload.schoolRating || [],
              ratingType,
              error: null,
            };
          }
        }
      }

      return state;

    case FAILURE:
      if (action.meta?.request === REQUEST_GET_RATING) {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      }
      return state;

    default:
      return state;
  }
};

export const fetchStartRating = (type = 'teacher', scope = 'all') => ({
  [RSAA]: {
    endpoint: `${host}/star-rating/?type=${type}&scope=${scope}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(t => ({
      type: t,
      meta: {
        request: REQUEST_GET_RATING,
        scope,
        ratingType: type,
      },
    })),
  },
});

export const fetchResetStars = (userIds = null) => ({
  [RSAA]: {
    endpoint: `${host}/star-rating/reset-stars`,
    method: 'POST',
    body: JSON.stringify({ userIds }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_RESET_STARS,
      },
    })),
  },
});

export default starRatingReducer;
